import { defineMessages } from 'react-intl';

/** The billable unit a product is priced by. */
export type BillableUnit = 'user' | 'creator' | 'agent';

export const messages = defineMessages({
	editionFieldLabel: {
		id: 'ubp.calculator.productcard.editionFieldLabel',
		defaultMessage: 'Edition',
	},
	freePlan: {
		id: 'ubp.calculator.productcard.freePlan',
		defaultMessage: 'Free plan — no charge.',
	},
});

/**
 * Per-unit price suffix, one full phrase per billable unit rather than a
 * `Per {unit}/month` frame with the noun interpolated: locales differ in word
 * order and in how the unit inflects after a preposition, so translators need
 * the whole phrase.
 */
export const perUnitPerMonthMessages = defineMessages<BillableUnit>({
	user: {
		id: 'ubp.calculator.productcard.perUnitPerMonth.user',
		defaultMessage: 'Per user/month',
	},
	creator: {
		id: 'ubp.calculator.productcard.perUnitPerMonth.creator',
		defaultMessage: 'Per creator/month',
	},
	agent: {
		id: 'ubp.calculator.productcard.perUnitPerMonth.agent',
		defaultMessage: 'Per agent/month',
	},
});

/** Plural unit noun labelling the unit-count input. */
export const unitLabelPluralMessages = defineMessages<BillableUnit>({
	user: {
		id: 'ubp.calculator.productcard.unitLabelPlural.user',
		defaultMessage: 'users',
	},
	creator: {
		id: 'ubp.calculator.productcard.unitLabelPlural.creator',
		defaultMessage: 'creators',
	},
	agent: {
		id: 'ubp.calculator.productcard.unitLabelPlural.agent',
		defaultMessage: 'agents',
	},
});
